//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: '儿童青少年视力<br/>健康档案管理系统',
      logo: 'https://m.eyenurse.net/wxaward/eye/special/eye/img/logo2.png?imageView2/1/w/80/h/80'
    };
  }
};